export default {
    container: 'bg-white rounded-lg shadow-lg border border-gray-100 p-2',
    link: 'block px-6 py-3 text-sm rounded-lg text-slate-800 hover:text-black hover:bg-gray-100',
    icon: 'mr-2 text-xs text-slate-600'
}